<template>
    <o-loading
        :full-page="props.fullPage"
        :active="props.active"
    >
        <div class="loading-icon" />
    </o-loading>
</template>

<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            active?: boolean;
            fullPage?: boolean;
        }>(),
        {
            active: true,
            fullPage: false,
        },
    );
</script>

<style lang="scss" scoped>
@keyframes spinAround {
    0% { transform: rotate(0); }
    100% { transform: rotate(359deg); }
}

.loading-overlay.is-full-page .loading-icon:after {
    top: calc(50% - 2.5em);
    left: calc(50% - 2.5em);
    width: 5em;
    height: 5em;
}

.loading-icon {
    position: relative;

    &:after {
        animation: spinAround .5s infinite linear;
        border: 2px solid #cecece;
        border-radius: 9999px;
        border-right-color: transparent;
        border-top-color: transparent;
        content: "";
        display: block;
        height: 1em;
        position: relative;
        width: 1em;
        position: absolute;
        top: calc(50% - 1.5em);
        left: calc(50% - 1.5em);
        width: 4em;
        height: 4em;
        border-width: .25em
    }
}

</style>
